import type { Routes } from '@angular/router';

import { AmpEmptyPage } from './empty-page.component';
import { AmpErrorPage } from './error-page.component';

export const ampDefaultRoutes: Routes = [
  { path: '', component: AmpEmptyPage, title: 'shell.nav.home' },
  { path: '**', component: AmpErrorPage, title: 'shell.error.title' },
];
